// @flow
import * as React from 'react';

import type { Sorting } from './sorting.types.js';

type Props = {|
  name: string,
  field: string,
  label: string,
  colSpan?: number,
  className?: string,
  innerClassName?: string,
  sorting: Sorting,
  onClick: Function,
  labelAlign?: string
|};

class SortableTh extends React.Component<Props> {
  render() {
    const {
      field,
      label,
      colSpan = 1,
      className = 'clickable-link',
      innerClassName = 'text-center',
      sorting,
      onClick,
      labelAlign = 'left'
    } = this.props;

    return (
      <th colSpan={colSpan} className={className} data-field={field} onClick={onClick}>
        <div className={innerClassName}>
          <span className="data-label-align" data-label-align={labelAlign}>
            {label}
          </span>
          <div className="sort-arrows pull-right sort-arrow-wrap">
            <div className="sort-arrows-wrap">
              <div className="sort-arrows">
                <span
                  className={`sorting-arrow ${
                    sorting.field === field && sorting.dir === 'asc' ? 'active' : 'inactive'
                  }`}
                >
                  <i className="icon arrow-up" />
                </span>
                <span
                  className={`sorting-arrow ${
                    sorting.field === field && sorting.dir === 'desc' ? 'active' : 'inactive'
                  }`}
                >
                  <i className="icon arrow" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </th>
    );
  }
}

export default SortableTh;
